import Vue from "vue";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
locale.use(lang);
import { Select, Option, Input, Form, FormItem, Col, Row, DatePicker, Tooltip, Dialog, Button, Radio, RadioGroup, RadioButton, Table, TableColumn, Card, TabPane, Tabs } from "element-ui";

Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Col);
Vue.use(Row);
Vue.use(Tooltip);
Vue.use(DatePicker);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Card);
Vue.use(Tabs);
Vue.use(TabPane);





